import { pluck } from '@fmnts/core/object';
import { SelectInputItem } from '@fmnts/declarative-forms/core';

const valueFromItem = pluck(['value']);

/**
 * @param value Value of the item
 *
 * @returns
 * A function that when called with an select item
 * returns `true` if the item value is equal to the
 * given `value`.
 *
 * @example
 * items.find(bySelectItemValueEqeqeq('123'))
 */
export function bySelectItemValueEqeqeq(
  value: unknown,
): (item: SelectInputItem) => boolean {
  return (item) => valueFromItem(item) === value;
}
